import {Labware} from 'components';
import {WELL_HOVER_MODE} from 'components/Labware';
import {
  Orientation,
  WELL_HOVER_INDEX_COLOR_POSITION,
  WellBottomProfile,
  WellSurfaceDataShape,
} from 'constants/dataEnum';
import {find} from 'lib/objectHelper';
import {useSelector} from 'react-redux';
import {useIntl} from 'react-intl';

function GuidanceManualPlateContainer() {
  const intl = useIntl();
  const {id, wellBottomProfile, wellShape, wellNumber} = useSelector((state) => state.plateTypeEditorState);
  const {selectedWellStyle} = useSelector((state) => state.reteachPlateState.manualReteachPlate);
  const availableLabwareState = useSelector((state) => state.availableLabwareState);
  const labware = find(availableLabwareState, {LabwareID: id});
  const {LabwareID, colCount, rowCount, isWellRectangle, isIFC, labwareIndexes} = labware;
  const getBottomWellImage = () => {
    switch (wellBottomProfile) {
      case WellBottomProfile.FLAT:
        return './svg/bottom-well/Flat.svg';
      case WellBottomProfile.CONYCAL:
        return './svg/bottom-well/V.svg';
      case WellBottomProfile.ROUNDED:
        return './svg/bottom-well/Rounded.svg';
      default:
        return '';
    }
  };

  const getWellShapeImage = () => {
    switch (wellShape) {
      case WellSurfaceDataShape.CIRCLE:
        return './svg/well-type/Ellipse.svg';
      case WellSurfaceDataShape.RECTANGLE:
        switch (wellNumber) {
          case 1:
            return './svg/well-type/Through.svg';
          case 8:
            return './svg/well-type/Horizontal.svg';
          case 12:
            return './svg/well-type/Vertical.svg';
          default:
            return './svg/well-type/Rectangle.svg';
        }

      default:
        return '';
    }
  };

  return (
    <div id="plate-guidance">
      <div className="plate-guidance-header">
        <div className="section-title bordered">Guidance</div>
      </div>

      <div className="plate-guidance-container">
        <div className="section-additional-info italic">
          {intl.formatMessage({id: 'plateTypeEditorContainer.manualReteachPlate.guidance.instruction'})}
        </div>
        <div className="plate-guidance-steps">
          <div className="steps-left">
            <div className="plate-guidance-steps__1">
              <div className="step-header">
                <div className="title">Step 1</div>
                <div className="instruction">
                  {intl.formatMessage({id: 'plateTypeEditorContainer.manualReteachPlate.guidance.instruction.step1'})}
                </div>
              </div>
              <div className="step-content">
                <div className="step-content__step-labware">
                  <div className="step-content__labware">
                    <Labware
                      ID={`labware-${LabwareID}`}
                      colCount={isIFC ? 1 : colCount}
                      rowCount={isIFC ? 1 : rowCount}
                      orientation={Orientation.POTRAIT}
                      isWellRectangle={isWellRectangle}
                      showColIdx={isIFC ? false : [1]}
                      showRowIdx={isIFC ? false : ['A']}
                      wellHoverMode={WELL_HOVER_MODE.NOTHING}
                      wellHoverHighlightPosition={WELL_HOVER_INDEX_COLOR_POSITION.BOTH}
                      wellStyle={selectedWellStyle}
                      isIFC={isIFC}
                      IFCvariant={colCount}
                      swipeEnable
                      showSelectionLine={false}
                      labwareIndexes={labwareIndexes}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="steps-right">
            <div className="plate-guidance-steps__2">
              <div className="step-header">
                <div className="title">Step 2</div>
                <div className="instruction">
                  {intl.formatMessage({id: 'plateTypeEditorContainer.manualReteachPlate.guidance.instruction.step2'})}
                </div>
              </div>
              <div className="step-content">
                <div className="step-content__step-well">
                  <img className="well-image" alt="Well Preview" src={getWellShapeImage()} />
                </div>
              </div>
              <div />
            </div>
            <div className="plate-guidance-steps__3">
              <div className="step-header">
                <div className="title">Step 3</div>
                <div className="instruction">
                  {intl.formatMessage({id: 'plateTypeEditorContainer.manualReteachPlate.guidance.instruction.step3'})}
                </div>
              </div>
              <div className="step-content">
                <div className="step-content__bottom-well">
                  <img className="well-image" alt="Bottom Well Preview" src={getBottomWellImage()} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuidanceManualPlateContainer;
